import type { AgentType } from './confluence-update-page-command';

const AGENT_TYPES: Record<AgentType, true> = {
	twg: true,
	mcp: true,
	'convo-ai': true,
	rovo_chat: true,
	unknown: true,
};

/** Validates an agent type received from an independently deployed bridge client. */
export const isAgentType = (value: unknown): value is AgentType =>
	typeof value === 'string' && Object.prototype.hasOwnProperty.call(AGENT_TYPES, value);
